<template>
  <form-builder-editor-field
    :item="item"
    :show-required="true"
    :show-hide-in-form="true"
    :show-hide-in-reports="true"
    :show-hide-in-preview="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <div v-if="'text' === item.type"
         class="form-group" >
      <label :for="item.name + '-placeholder'">Placeholder</label>
      <input :id="item.name + '-placeholder'" class="form-control" type="text"
             v-model="item.placeholder">
    </div>

    <div class="form-group" >
      <label class="active" :for="item.name + '-maxsize'">
        Maximum number of characters
      </label>
      <input :id="item.name + '-maxsize'" class="form-control" type="number"
             min="0"
             v-model.number="item.maxSize"
             :disabled="!!item.minSize"
             oninput="validity.valid||(value='');">
    </div>

    <div class="form-group">
      <label class="active" :for="item.name + '-maxsize'">
        Required number of characters
      </label>
      <input :id="item.name + '-minsize'" class="form-control" type="number"
             min="0"
             v-model.number="item.minSize"
             :disabled="!!item.maxSize"
             oninput="validity.valid||(value='');">
    </div>

    <div v-if="['text', 'password', 'email'].includes(item.type)"
         class="form-group">
      <label>Type</label>
      <select v-model="item.type" class="form-control">
        <option v-for="(option, index) in typeOptions"
                :key="'input-type-' + index" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";

export default {
  components: {FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    const typeOptions = [
      {
        label: "Text",
        value: "text",
      },
      {
        label: "Email",
        value: "email",
      },
      {
        label: "Password",
        value: "password",
      },
    ]
    return {
      typeOptions
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormBuilderEditorText.vue?7a71f8e7